import { render } from "./ReverseTokyoTalentList.vue?vue&type=template&id=b9602a56&scoped=true&ts=true&lang=pug"
import script from "./ReverseTokyoTalentList.vue?vue&type=script&lang=ts"
export * from "./ReverseTokyoTalentList.vue?vue&type=script&lang=ts"

import "./ReverseTokyoTalentList.vue?vue&type=style&index=0&id=b9602a56&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9602a56"]])

export default __exports__